/**
 * Utility function to merge Tailwind CSS classes
 * Handles conditional classes and removes duplicates
 */

export function cn(...classes) {
  return classes
    .filter(Boolean)
    .join(' ')
    .split(' ')
    .filter((value, index, self) => self.indexOf(value) === index)
    .join(' ');
}

export default cn;
